import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export type BatteryConfidenceTier = 'NEW' | 'NINETY_NINE' | 'STANDARD'

export function getBatteryConfidenceTier({
  specialOfferType,
  gradeId,
  countryCode,
}: {
  specialOfferType: number
  gradeId: number
  countryCode: string
}): BatteryConfidenceTier | null {
  if (specialOfferType === 9) {
    return 'NINETY_NINE'
  }

  if (specialOfferType === 7) {
    return countryCode === 'US' ? 'NINETY_NINE' : 'NEW'
  }

  if (specialOfferType === 0) {
    return gradeId === 9 ? 'NINETY_NINE' : 'STANDARD'
  }

  return null
}

export function useBatteryConfidenceTier() {
  const { market } = useMarketplace()

  return {
    getBatteryConfidenceTier: ({
      specialOfferType,
      gradeId,
    }: {
      specialOfferType: number
      gradeId: number
    }): BatteryConfidenceTier | null =>
      getBatteryConfidenceTier({
        specialOfferType,
        gradeId,
        countryCode: market.countryCode,
      }),
  }
}
